import { v4 } from "uuid";

export const CHANGE_FILTER = "addFilters/CHANGE_FILTER";
export const CHANGE_VALUES = "addFilters/CHANGE_VALUES";
export const DELETE_FILTER = "addFilters/DELETE_FILTER";
const LOADING = "addFilters/LOADING";
export const REFRESHING_FILTERS = "addFilters/REFRESHING_FILTERS";
const RESET_FILTERS = "addFilters/RESET_FILTERS";

const initialState = { filters: [], updatedAt: null };

const additionalFilters = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_FILTER: {
      const values = ["manaValue", "power", "price", "toughness"].includes(action.filter)
        ? { operator: ">", value: "" }
        : action.filter === "colors"
        ? {
            b: false,
            c: true,
            g: false,
            operator: "EXCLUSIVE ALL",
            r: false,
            u: false,
            w: false,
          }
        : action.filter === "rarity"
        ? { value: "common" }
        : action.filter === "sets"
        ? { operator: "INCLUDE", value: "" }
        : { value: "" };
      return {
        ...state,
        filters: [
          ...state.filters.slice(0, action.i),
          {
            key: v4(),
            type: action.filter,
            values,
          },
          ...state.filters.slice(action.i + 1),
        ],
      };
    }
    case CHANGE_VALUES: {
      let newValues = action.values;
      if (state.filters[action.i].type === "colors") {
        if (action.values.c !== undefined) {
          // Colorless handler
          newValues = {
            ...action.values,
            b: false,
            c: true,
            g: false,
            r: false,
            u: false,
            w: false,
          };
        } else if (["w", "u", "b", "r", "g"].includes(Object.keys(action.values)[0])) {
          // Colors handler
          newValues = {
            ...action.values,
            c: false,
          };
          const { operator, ...colors } = {
            ...state.filters[action.i].values,
            ...newValues,
          };
          // Checks colorless if nothing is checked
          if (!Object.values(colors).some((c) => c)) {
            newValues.c = true;
          }
        }
      }
      return {
        ...state,
        filters: [
          ...state.filters.slice(0, action.i),
          {
            ...state.filters[action.i],
            values: { ...state.filters[action.i].values, ...newValues },
          },
          ...state.filters.slice(action.i + 1),
        ],
      };
    }
    case DELETE_FILTER: {
      return {
        ...state,
        filters: [...state.filters.slice(0, action.i), ...state.filters.slice(action.i + 1)],
      };
    }
    case RESET_FILTERS: {
      return initialState;
    }
    case LOADING:
    case REFRESHING_FILTERS: {
      return { ...state, updatedAt: new Date().getTime() };
    }
    default: {
      return state;
    }
  }
};

export const filterCardlists = ({ cards, filters, initCardlists }) => {
  return initCardlists.map((cardlist) => ({
    ...cardlist,
    cardviews: cardlist.cardviews.filter((cardview) =>
      filterFuncs(filters).every((filterFunc) => {
        if (cardview.cards) {
          const cardFaces = cardview.cards.map((card) => cards[card.url]).filter((card) => card);
          return cardFaces.some(filterFunc);
        }
        const card = cards[cardview.sanitized];
        if (!card) {
          console.warn(`[Additional Filters] Card not found: ${cardview.sanitized}`);
          return false;
        }
        return filterFunc(card);
      })
    ),
  }));
};

export const handleChangeFilter =
  ({ e, i }) =>
  (dispatch) => {
    dispatch({ filter: e.target.value, i, type: CHANGE_FILTER });
  };

export const handleChangeValues =
  ({ i, values }) =>
  (dispatch) => {
    dispatch({ i, type: CHANGE_VALUES, values });
  };

export const handleDelete = (i) => (dispatch) => {
  dispatch({ i, type: DELETE_FILTER });
};

export const loading = () => (dispatch) => dispatch({ type: LOADING });

/* refreshFilters helper function
   Takes an array of filters and returns an array of functions
   Each function takes a card and returns a boolean */
const filterFuncs = (filters) =>
  filters.map(({ type, values }) => {
    switch (type) {
      case "cardName":
        return (card) => card.name.toLowerCase().includes(values.value.toLowerCase());
      case "typeLine":
        return (card) => card.type.toLowerCase().includes(values.value.toLowerCase());
      case "colors":
        return (card) => {
          if (card.color_identity === undefined) {
            return values.c || values.operator === "SOME";
          } else {
            switch (values.operator) {
              case "EXCLUSIVE ALL":
                return ["w", "u", "b", "r", "g"].every(
                  (c) => values[c] === card.color_identity.includes(c.toUpperCase())
                );
              case "INCLUSIVE ALL":
                return ["w", "u", "b", "r", "g"].every(
                  (c) => !values[c] || card.color_identity.includes(c.toUpperCase())
                );
              case "SOME":
                return ["w", "u", "b", "r", "g"].every(
                  (c) => values[c] || !card.color_identity.includes(c.toUpperCase())
                );
              default:
                console.warn("[Additional Filters] Unknown operator");
                return true;
            }
          }
        };
      case "manaValue":
      case "power":
      case "price":
      case "toughness":
        return (card) => {
          const cardValue =
            (type === "manaValue" ? card?.cmc : type === "price" ? card.prices.cardkingdom.price : card[type]) || 0;
          // eslint-disable-next-line no-eval
          return eval(`${parseInt(cardValue)}${values.operator}${parseInt(values.value)}`);
        };
      case "rarity":
        return (card) => {
          return card?.rarity === values.value;
        };
      case "sets":
        return (card) => {
          switch (values.operator) {
            case "INCLUDE":
              return values.sets.some((set) => card?.sets.includes(set));
            case "EXCLUDE":
              return !values.sets.some((set) => card?.sets.includes(set));
            default:
              console.warn("[Additional Filters] Unknown operator");
              return true;
          }
        };
      case "tags":
        return (card) => values.value.some((tag) => card?.tags?.includes(tag));
      default:
        console.warn("[Additional Filters] Unknown type");
        return true;
    }
  });

export const refreshFilters = () => async (dispatch, getState) => {
  const cards = getState().cards.cards;
  const filters = getState().additionalFilters.filters;
  const initCardlists = getState().pagedata.data.container.json_dict.initCardlists;

  const cardlists = filterCardlists({ cards, filters, initCardlists });

  dispatch({ cardlists, type: REFRESHING_FILTERS });
};

export const resetFilters = () => (dispatch) => {
  dispatch({ type: RESET_FILTERS });
  dispatch(refreshFilters());
};

export default additionalFilters;
